/* PDF Novi theme
   Reads products and topics from the #np-data block that Shopify renders,
   and talks to Shopify's cart through the AJAX Cart API. */
(function () {
"use strict";

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
const finePointer = matchMedia("(pointer: fine)").matches && !reduceMotion;

/* ---------- Data ---------- */
let DATA;
try { DATA = JSON.parse($("#np-data").textContent); } catch (e) { DATA = { topics: [], products: [], tiers: [], cart: { items: [], item_count: 0 } }; }
const ROOT = DATA.root || "/";
const url = path => (ROOT.endsWith("/") ? ROOT : ROOT + "/") + path.replace(/^\//, "");

// De-duplicate: the first time a product appears (inside a topic) wins.
const byId = new Map();
DATA.products.forEach(p => { if (!byId.has(p.id)) byId.set(p.id, p); else if (!byId.get(p.id).niche && p.niche) byId.set(p.id, p); });
try {
  const heroExtra = $("#np-hero-data") ? JSON.parse($("#np-hero-data").textContent) : [];
  heroExtra.forEach(p => { if (!byId.has(p.id)) byId.set(p.id, p); });
} catch (e) {}
const PRODUCTS = [...byId.values()];
const TOPICS = DATA.topics;
const inTopics = PRODUCTS.filter(p => p.niche);
const live = inTopics.filter(p => p.status === "live");
const prod = id => byId.get(id);
const FALLBACK_TOPIC = { id: "", name: "Guide", color: getComputedStyle(document.documentElement).getPropertyValue("--gilt").trim() || "#B8915C", motif: 0 };
const nicheOf = id => TOPICS.find(t => t.id === id) || FALLBACK_TOPIC;
const TIERS = [...(DATA.tiers || [])].sort((a, b) => a.min - b.min);

/* ---------- Money (uses the shop's own money format) ---------- */
function fmt(cents) {
  const f = DATA.moneyFormat || "{{amount}}";
  const n = (cents || 0) / 100;
  const group = (num, dec, th, ds) => {
    const [i, d] = num.toFixed(dec).split(".");
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : "");
  };
  return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount: group(n, 2, ",", "."),
    amount_no_decimals: group(n, 0, ",", "."),
    amount_with_comma_separator: group(n, 2, ".", ","),
    amount_no_decimals_with_comma_separator: group(n, 0, ".", ","),
    amount_with_apostrophe_separator: group(n, 2, "'", "."),
    amount_with_space_separator: group(n, 2, " ", ","),
  }[k] ?? group(n, 2, ",", "."))).replace(/<[^>]*>/g, "");
}

/* ---------- Generated covers for guides without artwork ---------- */
const MOTIFS = [
  c => `<svg class="g-motif" viewBox="0 0 200 200"><g fill="none" stroke="${c}" stroke-width="10"><ellipse cx="110" cy="150" rx="70" ry="22"/><path d="M40 150v-24c0 12 31 22 70 22s70-10 70-22v24"/><path d="M40 126v-24c0 12 31 22 70 22s70-10 70-22v24"/><ellipse cx="110" cy="102" rx="70" ry="22"/></g></svg>`,
  c => `<svg class="g-motif" viewBox="0 0 200 200"><path d="M150 40a70 70 0 1 0 0 120a56 56 0 1 1 0-120z" fill="${c}"/><circle cx="160" cy="70" r="6" fill="${c}"/><circle cx="178" cy="104" r="4" fill="${c}"/></svg>`,
  c => `<svg class="g-motif" viewBox="0 0 200 200"><g fill="none" stroke="${c}" stroke-width="10" stroke-linecap="round"><path d="M40 150a80 80 0 0 1 150-40"/><path d="M110 150l40-60"/></g><circle cx="110" cy="150" r="12" fill="${c}"/></svg>`,
  c => `<svg class="g-motif" viewBox="0 0 200 200"><g fill="none" stroke="${c}" stroke-width="10"><circle cx="85" cy="120" r="55"/><circle cx="140" cy="120" r="55"/></g></svg>`,
];
function isLight(hex) {
  const m = String(hex).replace("#", "").match(/^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i);
  if (!m) return false;
  const [r, g, b] = m.slice(1).map(x => parseInt(x, 16));
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6;
}
function genCover(p) {
  const n = nicheOf(p.niche);
  const light = isLight(n.color);
  const fg = light ? "#1A1D27" : "#F7F3EA";
  const motif = MOTIFS[(n.motif || 0) % MOTIFS.length](light ? "rgba(26,29,39,.25)" : "rgba(255,255,255,.22)");
  return `<div class="gcover" style="--cb:${n.color};--cf:${fg};--ca:${fg}">
    <span class="g-kicker">${esc(n.name)} guide</span>
    <span class="g-title">${esc(p.title)}</span>
    <span class="g-tag">${esc(p.tagline)}</span>
    ${motif}
  </div>`;
}
const coverHTML = (p, eager) => p.cover ? `<img src="${esc(p.cover)}" alt=""${eager ? "" : ' loading="lazy"'}>` : genCover(p);

/* ---------- Toast ---------- */
let tt;
function toast(msg) { const t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("on"); clearTimeout(tt); tt = setTimeout(() => t.classList.remove("on"), 4200); }

/* =========================================================
   CART (Shopify AJAX Cart API)
   ========================================================= */
let CART = DATA.cart || { items: [], item_count: 0 };
const cart = {
  handles() { return CART.items.map(i => i.handle); },
  has(handle) { return CART.items.some(i => i.handle === handle); },
  async refresh() {
    const r = await fetch(url("cart.js"), { headers: { Accept: "application/json" } });
    CART = await r.json(); renderBag(); return CART;
  },
  async add(handle, variantId) {
    const p = prod(handle);
    const id = variantId || p?.variant;
    if (!id) { location.href = p?.url || url("collections/all"); return false; }
    const r = await fetch(url("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    });
    if (!r.ok) {
      let msg = "Sorry, that guide couldn't be added.";
      try { const j = await r.json(); if (j.description) msg = j.description; } catch (e) {}
      toast(msg); return false;
    }
    await cart.refresh(); return true;
  },
  async remove(key) {
    const r = await fetch(url("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    CART = await r.json(); renderBag();
  },
};

function renderBag() {
  const countEl = $("#bagCount");
  if (countEl) countEl.textContent = CART.item_count;
  const floatCount = $("#bagFloatCount");
  if (floatCount) floatCount.textContent = CART.item_count;
  const lines = $("#lines"), foot = $("#drawerFoot");
  if (!lines) return;
  const handles = cart.handles();
  if (!CART.items.length) {
    lines.innerHTML = `<div class="bag-empty"><p>Your bag is empty. Start with a guide for the part of life you most want sorted.</p><a class="btn btn-ink" href="${$("#shop") ? "#shop" : url("collections/all")}" data-close data-goto="shop">Browse the guides</a></div>`;
    foot.innerHTML = "";
  } else {
    lines.innerHTML = CART.items.map(it => {
      const p = prod(it.handle);
      const thumb = p ? coverHTML(p) : (it.image ? `<img src="${esc(it.image)}" alt="">` : "");
      const sub = p ? [nicheOf(p.niche).id ? nicheOf(p.niche).name : "", p.pages ? `${p.pages}-page PDF` : "PDF"].filter(Boolean).join(", ") : "PDF";
      const was = it.original_line_price > it.final_line_price ? `<s class="was">${fmt(it.original_line_price)}</s> ` : "";
      return `<div class="line"><div class="th">${thumb}</div><div><h4>${esc(it.product_title)}</h4><small>${esc(sub)}${it.quantity > 1 ? ` &times; ${it.quantity}` : ""}</small><br><button class="rm" data-remove="${esc(it.key)}">Remove</button></div><span class="lp">${was}${fmt(it.final_line_price)}</span></div>`;
    }).join("") + (() => {
      const others = live.filter(p => !handles.includes(p.id));
      if (!others.length) return "";
      return `<p class="pair-h">Add to your bundle</p>` + others.slice(0, 2).map(p => `<div class="pair"><div class="th">${coverHTML(p)}</div><div><b>${esc(p.title)}</b><small>${fmt(p.price)}</small></div><button class="add" data-add="${esc(p.id)}" style="margin-left:auto">Add</button></div>`).join("");
    })();
    const count = CART.item_count;
    let nudge = "";
    if (TIERS.length) {
      const next = TIERS.find(d => count < d.min);
      const maxMin = TIERS[TIERS.length - 1].min;
      nudge = next
        ? `<div class="nudge">Add ${next.min - count} more guide${next.min - count > 1 ? "s" : ""} to save ${next.pct}%.<div class="bar"><i style="width:${Math.min(100, count / maxMin * 100)}%"></i></div></div>`
        : `<div class="nudge">You've unlocked the biggest bundle saving.<div class="bar"><i style="width:100%"></i></div></div>`;
    }
    const subtotal = CART.original_total_price ?? CART.items_subtotal_price;
    const discount = CART.total_discount || 0;
    foot.innerHTML = `${nudge}
      <div class="sum"><span>Subtotal</span><span>${fmt(subtotal)}</span></div>
      ${discount > 0 ? `<div class="sum disc"><span>Bundle saving</span><span>−${fmt(discount)}</span></div>` : ""}
      <div class="sum total"><span>Total</span><span>${fmt(CART.total_price)}</span></div>
      <a class="btn btn-gilt checkout magnetic" href="${url("checkout")}">Go to checkout</a>
      <p class="secure">Instant download after payment</p>`;
  }
  window.syncHeroCap && window.syncHeroCap();
  $$("[data-add]:not(.pair .add):not(.cap-btn)").forEach(b => {
    const inB = handles.includes(b.dataset.add);
    b.classList.toggle("in", inB); b.textContent = inB ? "In your bag" : "Add to bag";
  });
  bindMagnets();
}

function flyToBag(fromEl, p) {
  const fl = $("#bagFloat");
  const btn = fl && fl.classList.contains("on") ? fl : $("#bagBtn");
  if (!btn) return;
  btn.classList.remove("bump"); void btn.offsetWidth; btn.classList.add("bump");
  if (reduceMotion || !fromEl || !p) return;
  const a = fromEl.getBoundingClientRect(), b = btn.getBoundingClientRect();
  const f = document.createElement("div");
  f.className = "flyer";
  Object.assign(f.style, { left: a.left + "px", top: a.top + "px", width: a.width + "px", height: a.height + "px" });
  f.innerHTML = coverHTML(p, true);
  document.body.appendChild(f);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
  f.animate([
    { transform: "translate(0,0) scale(1) rotate(0)", opacity: 1 },
    { transform: `translate(${dx * .45}px,${dy * .45 - 80}px) scale(.55) rotate(-8deg)`, opacity: 1, offset: .5 },
    { transform: `translate(${dx}px,${dy}px) scale(.08) rotate(12deg)`, opacity: .3 },
  ], { duration: 800, easing: "cubic-bezier(.55,0,.3,1)" }).onfinish = () => f.remove();
}

/* =========================================================
   DRAWER + QUICK VIEW
   ========================================================= */
let lastFocus = null;
function lock(on) { document.body.style.overflow = on ? "hidden" : ""; document.body.classList.toggle("locked", on); }
function openDrawer() {
  if (!$("#drawer")) { location.href = url("cart"); return; }
  lastFocus = document.activeElement;
  $("#drawer").classList.add("on"); $("#drawer").setAttribute("aria-hidden", "false");
  $("#scrim").classList.add("on"); lock(true);
  setTimeout(() => $("#drawer .x")?.focus(), 50);
}
function closeAll() {
  $("#drawer")?.classList.remove("on"); $("#drawer")?.setAttribute("aria-hidden", "true");
  $("#modal")?.classList.remove("on"); $("#modal")?.setAttribute("aria-hidden", "true");
  $("#scrim")?.classList.remove("on"); lock(false);
  lastFocus?.focus?.();
}

function pagesOf(p) {
  const list = p.cover ? [{ src: p.cover, page: 1 }] : [{ gen: true, page: 1 }];
  (p.previews || []).forEach((pg, k) => list.push({ src: pg.src, thumb: pg.thumb, page: pg.page || k + 2 }));
  return list;
}
function viewerHTML(p) {
  const pages = pagesOf(p);
  return `<div class="page-frame">
      <div class="pg" data-pg></div>
      ${pages.length > 1 ? `<button class="nav-arrow l" data-step="-1" aria-label="Previous page"><svg><use href="#arrow"/></svg></button><button class="nav-arrow r" data-step="1" aria-label="Next page"><svg style="transform:scaleX(-1)"><use href="#arrow"/></svg></button>` : ""}
    </div>
    ${pages.length > 1 ? `<div class="thumbs">${pages.map((pg, i) => `<button data-page="${i}" aria-label="Show page ${pg.page}"><img src="${esc(pg.thumb || pg.src)}" alt="" loading="lazy"></button>`).join("")}</div>` : ""}
    <p class="pg-label" data-pg-label></p>`;
}
// A viewer is any element holding viewerHTML; several can exist (quick view + product page).
function mountViewer(root, p) {
  const v = { root, p, pages: pagesOf(p), i: 0 };
  root._viewer = v;
  showPage(v, 0, 0);
  let sx = null;
  root.addEventListener("touchstart", e => { sx = e.touches[0].clientX; }, { passive: true });
  root.addEventListener("touchend", e => { if (sx == null) return; const d = e.changedTouches[0].clientX - sx; if (Math.abs(d) > 45) showPage(v, v.i + (d < 0 ? 1 : -1), d < 0 ? 1 : -1); sx = null; });
  return v;
}
function showPage(v, i, dir) {
  const { pages, p, root } = v;
  i = (i + pages.length) % pages.length;
  v.i = i;
  const el = $("[data-pg]", root), label = $("[data-pg-label]", root);
  const paint = () => {
    const pg = pages[i];
    el.className = "pg" + (pg.gen ? " gen" : "");
    el.innerHTML = pg.gen ? genCover(p) : `<img src="${esc(pg.src)}" alt="Page ${pg.page} of ${esc(p.title)}">`;
    el.style.aspectRatio = p.ratio ? String(p.ratio) : "1/1.414";
    if (label) label.textContent = p.status === "live" ? (p.pages ? `Page ${pg.page} of ${p.pages}` : `Page ${pg.page}`) : "Cover preview";
    $$(".thumbs button", root).forEach((b, k) => b.setAttribute("aria-current", k === i));
  };
  if (!dir || reduceMotion) { paint(); return; }
  el.style.setProperty("--dir", (dir > 0 ? -24 : 24) + "px");
  el.classList.add("out");
  setTimeout(() => { el.style.setProperty("--dir", (dir > 0 ? 24 : -24) + "px"); paint(); el.classList.add("out"); requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove("out"))); }, 180);
}
let activeViewer = null;

function waitlistForm(p) {
  return `<form method="post" action="${url("contact#contact_form")}" accept-charset="UTF-8" class="form">
      <input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="contact[tags]" value="waitlist,waitlist-${esc(p.id)}">
      <label class="sr" for="wEmail">Email address</label>
      <input id="wEmail" type="email" name="contact[email]" placeholder="you@example.com" autocomplete="email" required>
      <button class="btn btn-ink" type="submit">Join waitlist</button>
    </form><p class="form-note" aria-live="polite"></p>`;
}

function openProduct(id) {
  const p = prod(id);
  if (!p) return false;
  if (!$("#modal")) { location.href = p.url; return true; }
  lastFocus = document.activeElement;
  const n = nicheOf(p.niche);
  const isLive = p.status === "live";
  const inBag = cart.has(p.id);
  const facts = [p.pages ? `${p.pages} pages${isLive ? "" : " planned"}` : "", p.format, p.time, isLive ? "Instant download" : ""].filter(Boolean);
  $("#sheet").innerHTML = `
    <div class="topbar">
      <button class="back" data-close><svg><use href="#arrow"/></svg>Back to guides</button>
      <button class="x" data-close aria-label="Close"><svg><use href="#close"/></svg></button>
    </div>
    <div class="viewer" data-viewer>${viewerHTML(p)}</div>
    <div class="info">
      ${n.id ? `<p class="card-niche" style="--c:${n.color};margin:0"><i></i>${esc(n.name)}</p>` : ""}
      <h2 id="mTitle">${esc(p.title)}</h2>
      <p class="lead">${esc(p.description)}</p>
      ${facts.length ? `<div class="facts">${facts.map(f => `<span>${esc(f)}</span>`).join("")}</div>` : ""}
      ${p.includes?.length ? `<h4>${isLive ? "Inside the guide" : "What it will include"}</h4>
      <ul class="inc">${p.includes.map(t => `<li><svg><use href="#check"/></svg><span>${esc(t)}</span></li>`).join("")}</ul>` : ""}
      <p class="more-link"><a href="${esc(p.url)}">Full guide page</a></p>
      ${isLive
        ? `<div class="buy"><span class="price">${fmt(p.price)}${p.compare > p.price ? ` <s class="was">${fmt(p.compare)}</s>` : ""}</span><button class="btn btn-ink magnetic" data-add="${esc(p.id)}" data-from="modal">${inBag ? "In your bag" : "Add to bag"}</button></div>`
        : `<div class="wait-form"><p>This guide isn't out yet. Leave your email and you'll hear the day it launches.</p>${waitlistForm(p)}</div>`}
    </div>`;
  activeViewer = mountViewer($("[data-viewer]", $("#sheet")), p);
  $("#modal").classList.add("on"); $("#modal").setAttribute("aria-hidden", "false");
  $("#scrim").classList.add("on"); lock(true);
  bindMagnets();
  setTimeout(() => $("#sheet .back")?.focus(), 60);
  return true;
}

/* =========================================================
   HOME: TOPICS, GRID, FILTERS
   ========================================================= */
const state = { niche: "all", showAll: false, revealFrom: 0 };
const PREVIEW = DATA.previewCount || 4;

function cardHTML(p, i) {
  const n = nicheOf(p.niche);
  const isLive = p.status === "live";
  const inBag = cart.has(p.id);
  return `<article class="card" style="--i:${i};--c:${n.color}">
    <a class="cover-btn" href="${esc(p.url)}" data-open="${esc(p.id)}" aria-label="${esc(p.title)}">
      <div class="shell"><div class="shadow"></div><div class="face">${coverHTML(p)}</div>${isLive ? "" : '<span class="badge">Coming soon</span>'}</div>
    </a>
    ${n.id ? `<p class="card-niche"><i></i>${esc(n.name)}</p>` : ""}
    <h3><a href="${esc(p.url)}" data-open="${esc(p.id)}">${esc(p.title)}</a></h3>
    <p class="card-tag">${esc(p.tagline)}</p>
    <div class="card-foot">
      ${isLive
        ? `<span class="price">${fmt(p.price)}</span>${p.pages ? `<span class="meta">${p.pages} pages</span>` : ""}`
        : (p.pages ? `<span class="meta">${p.pages} pages planned</span>` : "")}
      ${isLive
        ? `<button class="add magnetic${inBag ? " in" : ""}" type="button" data-add="${esc(p.id)}">${inBag ? "In your bag" : "Add to bag"}</button>`
        : `<a class="add wait" href="${esc(p.url)}" data-open="${esc(p.id)}">Join waitlist</a>`}
    </div>
  </article>`;
}

function renderShelves() {
  const el = $("#shelfGrid"); if (!el) return;
  el.innerHTML = TOPICS.map(n => {
    const ps = inTopics.filter(p => p.niche === n.id);
    const lc = ps.filter(p => p.status === "live").length;
    const count = !ps.length ? "Coming soon" : lc ? `${lc} available now${ps.length - lc ? `, ${ps.length - lc} coming soon` : ""}` : `${ps.length} guide${ps.length > 1 ? "s" : ""} coming soon`;
    return `<a class="shelf" href="${esc(n.url)}" style="--c:${n.color}" data-shelf="${esc(n.id)}">
      <h3>${esc(n.name)}</h3>${n.blurb ? `<p>${esc(n.blurb)}</p>` : ""}<span class="shelf-count">${count}</span>
      <div class="shelf-covers" aria-hidden="true">${ps.slice(0, 3).map(p => `<div>${coverHTML(p)}</div>`).join("")}</div>
    </a>`;
  }).join("");
}

function renderFilters() {
  const el = $("#filters"); if (!el) return;
  const chips = [{ id: "all", name: "All topics", color: null }, ...TOPICS];
  el.innerHTML = chips.map(c => {
    const n = c.id === "all" ? inTopics.length : inTopics.filter(p => p.niche === c.id).length;
    return `<button class="chip" style="${c.color ? `--c:${c.color}` : ""}" data-filter="${esc(c.id)}" aria-pressed="${state.niche === c.id}">${c.color ? '<span class="dot"></span>' : ""}${esc(c.name)} <small>${n}</small></button>`;
  }).join("");
}

function renderGrid() {
  const grid = $("#grid"); if (!grid) return;
  let items = inTopics.filter(p => state.niche === "all" || p.niche === state.niche);
  items = [...items.filter(p => p.status === "live"), ...items.filter(p => p.status !== "live")];
  if (state.niche === "all") {
    // Mix topics in turn: one guide from each collection, then repeat
    const mix = list => {
      const groups = TOPICS.map(t => list.filter(p => p.niche === t.id));
      const out = [];
      for (let i = 0; groups.some(g => i < g.length); i++) groups.forEach(g => { if (i < g.length) out.push(g[i]); });
      return out;
    };
    items = [...mix(items.filter(p => p.status === "live")), ...mix(items.filter(p => p.status !== "live"))];
  }
  const title = $("#shopTitle");
  if (title) title.textContent = state.niche === "all" ? (title.dataset.allLabel || "All guides") : `${nicheOf(state.niche).name} guides`;
  const more = $("#moreWrap");
  if (!items.length) { grid.innerHTML = `<p class="empty">No guides here yet.</p>`; if (more) { more.hidden = true; more.innerHTML = ""; } return; }
  const total = items.length;
  const limited = !state.showAll && total > PREVIEW;
  const startAt = state.revealFrom; state.revealFrom = 0;
  if (limited) items = items.slice(0, PREVIEW);
  grid.innerHTML = items.map((p, i) => cardHTML(p, Math.max(0, i - startAt))).join("");
  if (more) {
    if (total > PREVIEW) {
      more.hidden = false;
      more.innerHTML = state.showAll
        ? `<button class="btn more-btn" id="moreBtn" aria-expanded="true">Show fewer</button>`
        : `<p>Showing ${PREVIEW} of ${total} guides</p><button class="btn more-btn" id="moreBtn" aria-expanded="false">Show more</button>`;
    } else { more.hidden = true; more.innerHTML = ""; }
  }
  bindTilt(); bindMagnets();
}
function setNiche(id, scroll) {
  state.niche = id; state.showAll = false;
  renderFilters(); renderGrid();
  if (scroll) $("#shop")?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
}

function renderRelated() {
  const g = $("#relatedGrid"); if (!g) return;
  const items = inTopics.filter(p => p.niche === g.dataset.topic && p.id !== g.dataset.exclude).slice(0, 4);
  if (!items.length) { g.closest(".related")?.remove(); return; }
  g.innerHTML = items.map((p, i) => cardHTML(p, i)).join("");
  bindTilt(); bindMagnets();
}

/* ---------- FAQ open/close animation ---------- */
$$("#faqList details").forEach(d => {
  const s = $("summary", d), body = $(".ans", d);
  s.addEventListener("click", e => {
    if (reduceMotion) return;
    e.preventDefault();
    if (d.open) {
      body.animate([{ height: body.scrollHeight + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: 300, easing: "ease" }).onfinish = () => d.open = false;
    } else {
      d.open = true;
      body.animate([{ height: "0px", opacity: 0 }, { height: body.scrollHeight + "px", opacity: 1 }], { duration: 380, easing: "cubic-bezier(.2,.8,.2,1)" });
    }
  });
});

/* ---------- Email forms (newsletter, waitlist) ---------- */
document.addEventListener("submit", e => {
  const f = e.target;
  const input = f.querySelector('input[name="contact[email]"]');
  if (!input) return;
  const note = f.nextElementSibling?.classList.contains("form-note") ? f.nextElementSibling : null;
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) {
    e.preventDefault();
    if (note) { note.className = "form-note err"; note.textContent = "Enter an email address like name@example.com."; }
    input.focus();
  }
});
if (/[?&]customer_posted=true/.test(location.search)) {
  setTimeout(() => toast("You're signed up. We'll email you when there's news."), 400);
  $$(".form-note").forEach(n => { if (n.previousElementSibling?.querySelector?.('input[name="contact[email]"]')) { n.className = "form-note ok"; n.textContent = "You're signed up."; } });
}

/* =========================================================
   CLICKS + KEYS
   ========================================================= */
document.addEventListener("click", async e => {
  const t = e.target;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let people open links in a new tab
  const add = t.closest("[data-add]");
  if (add) {
    e.preventDefault();
    const id = add.dataset.add, p = prod(id);
    if (cart.has(id)) { openDrawer(); return; }
    add.disabled = true;
    const ok = await cart.add(id, add.dataset.variant);
    add.disabled = false;
    if (!ok) return;
    const from = add.dataset.from === "modal" ? $("#sheet [data-pg]") : add.dataset.from === "hero" ? $(".slide.is-front .sface") : add.dataset.from === "page" ? $("#ppViewer [data-pg], #ppViewer .pg") : add.closest(".card")?.querySelector(".face");
    flyToBag(from, p);
    toast(`Added ${p ? p.title : "guide"}.`);
    return;
  }
  const open = t.closest("[data-open]");
  if (open) { if (openProduct(open.dataset.open)) e.preventDefault(); return; }
  const rm = t.closest("[data-remove]"); if (rm) { e.preventDefault(); cart.remove(rm.dataset.remove); return; }
  const shelf = t.closest("[data-shelf]");
  if (shelf && $("#grid")) { e.preventDefault(); setNiche(shelf.dataset.shelf, true); return; }
  const fl = t.closest("[data-filter]"); if (fl) { setNiche(fl.dataset.filter); return; }
  if (t.closest("#bagBtn, #bagFloat")) { e.preventDefault(); openDrawer(); return; }
  if (t.closest("#moreBtn")) {
    if (state.showAll) { state.showAll = false; renderGrid(); $("#shop")?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" }); }
    else { state.showAll = true; state.revealFrom = PREVIEW; renderGrid(); }
    return;
  }
  const vRoot = t.closest("[data-viewer], #ppViewer");
  const v = vRoot?._viewer;
  const step = t.closest("[data-step]"); if (step && v) { showPage(v, v.i + +step.dataset.step, +step.dataset.step); return; }
  const pg = t.closest("[data-page]"); if (pg && v) { const k = +pg.dataset.page; showPage(v, k, k > v.i ? 1 : -1); return; }
  const close = t.closest("[data-close]");
  if (close) {
    const goto = close.dataset.goto && document.getElementById(close.dataset.goto);
    if (goto) e.preventDefault();
    closeAll();
    if (goto) setTimeout(() => goto.scrollIntoView({ behavior: "smooth" }), 300);
    return;
  }
  if (t === $("#scrim") || t === $("#modal")) closeAll();
});
document.addEventListener("keydown", e => {
  const modalOn = $("#modal")?.classList.contains("on");
  if (e.key === "Escape") closeAll();
  if (modalOn && activeViewer && activeViewer.pages.length > 1 && !e.target.matches("input")) {
    if (e.key === "ArrowRight") showPage(activeViewer, activeViewer.i + 1, 1);
    if (e.key === "ArrowLeft") showPage(activeViewer, activeViewer.i - 1, -1);
  }
  if (e.key === "Tab" && (modalOn || $("#drawer")?.classList.contains("on"))) {
    const box = modalOn ? $("#sheet") : $("#drawer");
    const f = $$("button,a[href],input", box).filter(x => !x.disabled && x.offsetParent);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
});

/* =========================================================
   POINTER EFFECTS
   ========================================================= */
function bindTilt() {
  if (!finePointer) return;
  $$(".cover-btn").forEach(btn => {
    if (btn._tilt) return; btn._tilt = true;
    const shell = $(".shell", btn);
    btn.addEventListener("pointermove", e => {
      const r = shell.getBoundingClientRect();
      const x = e.clientX - r.left, y = e.clientY - r.top;
      shell.style.setProperty("--rx", ((y / r.height - .5) * -9) + "deg");
      shell.style.setProperty("--ry", ((x / r.width - .5) * 11) + "deg");
    });
    btn.addEventListener("pointerleave", () => { shell.style.setProperty("--rx", "0deg"); shell.style.setProperty("--ry", "0deg"); });
  });
}
function bindMagnets() {
  if (!finePointer) return;
  $$(".magnetic").forEach(el => {
    if (el._mag) return; el._mag = true;
    el.style.transition = (el.style.transition ? el.style.transition + "," : "") + "transform .35s cubic-bezier(.2,.8,.2,1)";
    el.addEventListener("pointermove", e => {
      const r = el.getBoundingClientRect();
      el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .22}px,${(e.clientY - r.top - r.height / 2) * .3}px)`;
    });
    el.addEventListener("pointerleave", () => el.style.transform = "");
  });
}

/* =========================================================
   HERO SHOWCASE (rotating guides)
   ========================================================= */
(function heroShow() {
  const show = $("#show"); if (!show) return;
  const stage = $("#stage"), cap = $("#showCap"), dotsEl = $("#sdots"), hero = $("#hero");
  let handles = [];
  try { handles = JSON.parse(show.dataset.handles || "[]"); } catch (e) {}
  const items = handles.length ? handles.map(prod).filter(Boolean) : live;
  const n = items.length;
  if (!n) { show.hidden = true; return; }
  let cur = 0, elapsed = 0, last = performance.now(), paused = false, hovering = false;
  const DURATION = (+show.dataset.autoplay || 5) * 1000;

  stage.insertAdjacentHTML("beforeend", items.map((p, i) => `
    <button class="slide" data-slide="${i}" aria-label="${esc(p.title)}">
      <span class="sshadow"></span>
      <span class="sface">${coverHTML(p, true)}</span>
      <span class="sring"></span>
    </button>`).join(""));
  dotsEl.innerHTML = items.map((p, i) => `<button class="sdot" data-dot="${i}" aria-label="Show ${esc(p.title)}"><i></i></button>`).join("");
  const slides = $$(".slide", stage), dots = $$(".sdot", dotsEl);

  const offset = i => { let o = i - cur; if (o > n / 2) o -= n; if (o < -n / 2) o += n; return o; };
  function layout() {
    slides.forEach((s, i) => {
      const o = offset(i), a = Math.abs(o);
      s.style.setProperty("--o", o); s.style.setProperty("--a", a);
      s.style.zIndex = 20 - a;
      s.classList.toggle("is-front", o === 0);
      s.classList.toggle("far", a > 2);
      s.tabIndex = o === 0 ? 0 : -1;
      s.setAttribute("aria-label", o === 0 ? `Look inside ${items[i].title}` : `Show ${items[i].title}`);
    });
    dots.forEach((d, i) => d.setAttribute("aria-current", i === cur));
  }
  function caption(animate) {
    const p = items[cur], nc = nicheOf(p.niche), inBag = cart.has(p.id);
    const html = `
      ${nc.id ? `<span class="cap-niche" style="--c:${nc.color}"><i></i>${esc(nc.name)}</span>` : `<span class="cap-niche">&nbsp;</span>`}
      <h2 class="cap-title">${esc(p.title)}</h2>
      <p class="cap-tag">${esc(p.tagline)}</p>
      <div class="cap-row">
        ${p.status === "live" ? `<span class="cap-price">${fmt(p.price)}</span><button class="cap-btn solid${inBag ? " in" : ""}" data-add="${esc(p.id)}" data-from="hero">${inBag ? "In your bag" : "Add to bag"}</button>` : `<button class="cap-btn" data-open="${esc(p.id)}">Join waitlist</button>`}
      </div>`;
    if (!animate || reduceMotion) { cap.innerHTML = html; return; }
    cap.classList.add("swap");
    setTimeout(() => { cap.innerHTML = html; cap.classList.add("swap"); requestAnimationFrame(() => requestAnimationFrame(() => cap.classList.remove("swap"))); }, 220);
  }
  window.syncHeroCap = () => {
    const b = $(".cap-btn.solid", cap); if (!b) return;
    const inBag = cart.has(b.dataset.add);
    b.classList.toggle("in", inBag); b.textContent = inBag ? "In your bag" : "Add to bag";
  };
  function go(i) {
    const next = ((i % n) + n) % n;
    if (next === cur) return;
    cur = next; elapsed = 0;
    layout(); caption(true);
  }
  function tick(now) {
    const dt = now - last; last = now;
    const blocked = paused || hovering || reduceMotion || document.hidden || document.body.classList.contains("locked") || hero.getBoundingClientRect().bottom < 0;
    if (!blocked) { elapsed += dt; if (elapsed >= DURATION) go(cur + 1); }
    dots[cur]?.style.setProperty("--prog", Math.min(100, elapsed / DURATION * 100) + "%");
    requestAnimationFrame(tick);
  }
  let dragged = false;
  stage.addEventListener("click", e => {
    const s = e.target.closest(".slide"); if (!s) return;
    e.stopPropagation();
    if (dragged) { dragged = false; return; }
    const i = +s.dataset.slide;
    if (i === cur) openProduct(items[i].id); else go(i);
  });
  dotsEl.addEventListener("click", e => { const d = e.target.closest("[data-dot]"); if (d) { e.stopPropagation(); go(+d.dataset.dot); } });
  $$("[data-sh]", show).forEach(b => b.addEventListener("click", e => { e.stopPropagation(); go(cur + +b.dataset.sh); }));
  stage.addEventListener("keydown", e => {
    if (e.key === "ArrowRight") { e.preventDefault(); go(cur + 1); }
    if (e.key === "ArrowLeft") { e.preventDefault(); go(cur - 1); }
    if (e.key === "Enter" && e.target === stage) openProduct(items[cur].id);
  });
  show.addEventListener("focusin", () => paused = true);
  show.addEventListener("focusout", () => paused = false);
  let sx = null;
  stage.addEventListener("pointerdown", e => { sx = e.clientX; dragged = false; });
  addEventListener("pointerup", e => {
    if (sx == null) return;
    const d = e.clientX - sx; sx = null;
    if (Math.abs(d) > 40) { dragged = true; go(cur + (d < 0 ? 1 : -1)); setTimeout(() => dragged = false, 50); }
  });
  if (finePointer) {
    show.addEventListener("pointerenter", () => hovering = true);
    show.addEventListener("pointerleave", () => hovering = false);
  }
  layout(); caption(false);
  requestAnimationFrame(t => { last = t; requestAnimationFrame(tick); });
})();

/* =========================================================
   QUICK-JUMP BAR (home page)
   ========================================================= */
(function dock() {
  const d = $("#dock"); if (!d) return;
  const pill = $(".dock-pill", d), links = $$("a", d), navLinks = $$(".dock-links a", d);
  const secs = ["hero", "shelves", "shop", "bundles", "how", "faq"].map(id => document.getElementById(id)).filter(Boolean);
  // Hide links whose section has been removed in the theme editor.
  navLinks.forEach(a => { if (!document.getElementById(a.dataset.sec)) a.hidden = true; });
  function movePill(a) {
    if (!a) { pill.style.opacity = 0; return; }
    pill.style.opacity = 1; pill.style.width = a.offsetWidth + "px"; pill.style.transform = `translateX(${a.offsetLeft}px)`;
  }
  function lum(el) {
    while (el && el !== document.documentElement) {
      const c = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if (c && (c.length < 4 || +c[3] > .5)) return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255;
      el = el.parentElement;
    }
    return 1;
  }
  function tone() {
    const r = d.getBoundingClientRect();
    const under = document.elementsFromPoint(r.left + r.width / 2, r.top + r.height / 2).find(el => !d.contains(el) && el !== d);
    d.classList.toggle("on-light", lum(under) > .55);
  }
  function update() {
    d.classList.toggle("on", scrollY > innerHeight * .45);
    tone();
    if (!secs.length) return;
    const mid = innerHeight * .4;
    let cur = secs[0];
    secs.forEach(s => { if (s.getBoundingClientRect().top <= mid) cur = s; });
    navLinks.forEach(a => a.classList.toggle("active", a.dataset.sec === cur.id));
    movePill(navLinks.find(a => a.dataset.sec === cur.id));
  }
  addEventListener("scroll", update, { passive: true });
  addEventListener("resize", update);
  links.forEach(a => a.addEventListener("click", e => {
    e.preventDefault();
    if (a.dataset.sec === "hero") { scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" }); return; }
    document.getElementById(a.dataset.sec)?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
  }));
  update();
})();

/* =========================================================
   PRODUCT PAGE VIEWER
   ========================================================= */
(function productPage() {
  const page = $("#productPage"); if (!page) return;
  const p = prod(page.dataset.handle);
  const root = $("#ppViewer");
  if (!p || !root) return;
  root.innerHTML = viewerHTML(p);
  mountViewer(root, p);
})();

/* Hide the product form fallback button text sync on product page */
$$(".pp-form").forEach(f => f.addEventListener("submit", e => { e.preventDefault(); }));

/* ---------- Boot ---------- */
renderShelves(); renderFilters(); renderGrid(); renderRelated(); renderBag(); bindTilt(); bindMagnets();

// Keep the bag in sync if it changed in another tab or via the cart page.
addEventListener("pageshow", e => { if (e.persisted) cart.refresh().catch(() => {}); });
})();


/* Floating bag island: always visible */
(() => {
  const fl = document.getElementById("bagFloat");
  if (!fl) return;
  fl.classList.add("on");
})();
